import { formatErrorForLogging, logger } from 'utils/logger';
import { FILTERED } from 'utils/sentry/redactIceServers';
import { BucketTransition, PressureContext, TickSnapshot } from 'utils/webrtc/stats/types';

const BROADCASTER_CADENCE = 5; // ≈10 s at 0.5 Hz — one emission per ~2 hysteresis windows
const LISTENER_CADENCE = 15; // ≈30 s at 0.5 Hz

const remote = () => logger.remote({ capture: 'webrtc-scores', tier: 0, nonProd: true });

export const logTick = (snapshot: TickSnapshot, isBroadcaster: boolean): void => {
  const cadence = isBroadcaster ? BROADCASTER_CADENCE : LISTENER_CADENCE;
  if (snapshot.tickNumber % cadence !== 0) {
    return;
  }
  remote().info('webrtc-scores:tick', { isBroadcaster, ...snapshot });
};

export const logBucketTransition = (transition: BucketTransition): void => {
  remote().info('webrtc-scores:bucket', transition);
};

/** Emitted once per PC generation; a PC_n pcId confirms the wrapper tagged it. */
export const logWrappedPc = (pc: { pcKey: string; pcId: string }): void => {
  remote().info('webrtc-scores:pc-wrapped', pc);
};

// The socket URL carries the rtcstats auth token in its query; WebSocket errors can echo it.
const URL_QUERY = /\?[^\s'"]*/g;

export const logTraceDisabled = (stage: 'connect' | 'emit', error: unknown): void => {
  const { name, message } = formatErrorForLogging(error);
  logger.remote({ system: true }).warn(`[rtcstats] trace disabled — library threw on ${stage}`, {
    error: { name, message: message.replace(URL_QUERY, `?${FILTERED}`) },
  });
};

export const logPressure = (durationMs: number, ctx: PressureContext): void => {
  remote().warn('webrtc-scores:pressure', { durationMs, ...ctx });
};
